import { useParams, Navigate } from "react-router-dom";

/**
 * Handles URL-encoded auth paths like /auth%3Fmode=signup
 * and redirects to the correct /auth?mode=signup path.
 * This fixes 404 errors caused by double-encoded URLs from external links or email templates.
 */
const EncodedAuthRedirect = () => {
  const { encodedPath } = useParams();
  
  if (encodedPath) {
    // Decode the path - it might contain encoded query params like "auth%3Fmode=signup"
    const decoded = decodeURIComponent(encodedPath);
    
    // Check if it starts with "auth" and contains a query string marker
    if (decoded.startsWith('auth') && decoded.includes('?')) {
      const queryStart = decoded.indexOf('?');
      const queryString = decoded.substring(queryStart);
      return <Navigate to={`/auth${queryString}`} replace />;
    }
  }
  
  // If not an encoded auth path, show 404
  return <Navigate to="/404" replace />;
};

export default EncodedAuthRedirect;
